import {DecimalPipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {MatCheckbox} from '@angular/material/checkbox'
import {filter, switchMap} from 'rxjs/operators'
import {TermsTexts, TTermDuration, TTermText} from '../../model/terms-texts'
import {ControlService} from '../../services/control.service'
import {KalpService, LegacyKalp, Scenarios} from '../../services/kalp.service'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'

export interface ExistingLoanInput {
  amount: number
  interest: number
  mortgage: number
  terms: string
  expires: string
  solve: boolean
}

@Component({
  selector: 'spb-existing-display',
  templateUrl: './existing-display.component.html',
  styleUrls: ['./existing-display.component.scss'],
  imports: [MatCheckbox, DecimalPipe]
})
export class ExistingDisplayComponent implements OnInit {
  public controlService = inject(ControlService)
  public loans: ExistingLoanInput[] = []


  private scenario: Scenarios = Scenarios.Conditions

  private readonly kalpService = inject(KalpService)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  get conditions(): boolean {
    return this.scenario === Scenarios.Conditions
  }

  public ngOnInit(): void {
    this.kalpService.scenarioChange$
      .pipe(
        this.takeUntilDestroyed(),
        filter(Boolean),
        switchMap((scenario: Scenarios) => {
          this.scenario = scenario
          return this.kalpService.kalpResult$
        })
      )
      .subscribe((kalps: LegacyKalp[]) => {
        // In theory... all loans on the first kalp that is "mortgage" loan
        // are the ones we should display here.
        this.loans = kalps[0].loans.loans
          .filter(loan => !loan.isBlancoLoan)
          .map(loan => ({
            amount: loan.amount,
            mortgage: loan.mortgageAmount,
            interest: loan.interestPercent * 100,
            terms: this.selectTerms(loan.terms),
            expires: loan.changeDate,
            solve: loan.solve
          }))
      })
  }

  private selectTerms(terms: TTermDuration): TTermText {
    return TermsTexts.getByMonths(terms).text
  }
}
